<template>
	<div class="w100 bgGrey">
		<div class="service-top-box bgDark">
			<Header></Header>
		</div>

		<!-- 顶部二级菜单部分 -->
		<div class="s-top-container w100">
			<div class="c-content">
				<el-row v-show="fwTab == 1">
					<el-col :span="12">
						<div class="c-content-left">
							<h2>大数据项目服务</h2>
							<h3>打造属于企业自身的大数据平台</h3>
							<p class="fontLight">依托唐宋大数据完善的数据、算法和技术能力，融合客户自身的数据和业务，为企业量身定制智慧经营决策系统</p>
							<p class="fontLight">
								该系统主要包括数据集成、可视化算法集成、预测分析报告、市场商情等内容，全面融入唐宋十余年算法研究成果，指导企业市场预判、购销决策以及期现货交易等</p>
<!-- 							<div class="nr-tab">
								<a href="javascript:;" class="nr-btn" :class="{'nr-active': nrTab == 1}">具体内容</a>
								<a href="javascript:;" class="nr-btn" :class="{'nr-active': nrTab == 2}">想展示内容</a>
							</div> -->
						</div>
					</el-col>
					<el-col :span="12">
						<div class="c-content-right">
							<img src="../../assets/images/service_new/big_data.png" class="w100" alt="" srcset="">
						</div>
					</el-col>
				</el-row>

				<el-row v-show="fwTab == 2">
					<el-col :span="12">
						<div class="c-content-left">
							<h2>唐宋钢铁APP</h2>
							<h3>打造属于企业自身的APP</h3>
							<p class="fontLight">
								唐宋公司推出的智能手机应用软件，以信息平台为依托打造的唐宋钢铁用户专用的信息通道，推出商务中心、资讯中心、实时期货中心等功能应用平台。提供更稳定的接收、更便捷的订阅、更丰富的内容，让客户能够随时随地了解钢铁行业动态，为客户提供市场决策参考。
							</p>
<!-- 							<div class="nr-tab">
								<a href="javascript:;" class="nr-btn" :class="{'nr-active': nrTab == 1}">具体内容</a>
								<a href="javascript:;" class="nr-btn" :class="{'nr-active': nrTab == 2}">想展示内容</a>
							</div> -->
						</div>
					</el-col>
					<el-col :span="12">
						<div class="c-content-right">
							<img src="../../assets/images/service_new/ydd.png" class="w100" alt="" srcset="">
						</div>
					</el-col>
				</el-row>
				
				<el-row v-show="fwTab == 3">
					<el-col :span="13">
						<div class="c-content-left">
							<h2>钢铁市场分析预测体系与算法精要培训班</h2>
							<h3>研究大成  预测秘籍</h3>
							<p class="fontLight">
								唐宋公司总经理宋雷先生在十六年时间里，一直在思考有没有更好的分析预测逻辑，可以看到市场更本质的东西，能够定性，可以计算。随着时间的推移，从偶有感悟，到渐成体系，最终有了一套比较完整的全新的逻辑架构。
							</p>
<!-- 							<div class="nr-tab">
								<a href="javascript:;" class="nr-btn" :class="{'nr-active': nrTab == 1}">具体内容</a>
								<a href="javascript:;" class="nr-btn" :class="{'nr-active': nrTab == 2}">想展示内容</a>
							</div> -->
						</div>
					</el-col>
					<el-col :span="11">
						<div class="c-content-right textCenter">
							<img src="../../assets/images/service_new/px.png" style="height: 100%;margin-bottom: -42px;" alt="" srcset="">
						</div>
					</el-col>
				</el-row>
				
				<el-row v-show="fwTab == 4">
					<el-col :span="12">
						<div class="c-content-left">
							<h2>唐宋钢铁在线监测预警系统</h2>
							<h3>国内一流行业智能决策平台</h3>
							<p class="fontLight">
								唐宋钢铁在线监测预警平台是唐宋集团依托自有研发团队打造的国内一流行业智能决策平台，在唐宋数据库、信息平台和唐宋钢铁经济研究院一系列研究成果的基础上，建立行业专家定期审定制度，利用一系列经济指标、技术指标建立起来的市场和行业的“晴雨表”和“报警器”。
							</p>
<!-- 							<div class="nr-tab">
								<a href="javascript:;" class="nr-btn" :class="{'nr-active': nrTab == 1}">具体内容</a>
								<a href="javascript:;" class="nr-btn" :class="{'nr-active': nrTab == 2}">想展示内容</a>
							</div> -->
						</div>
					</el-col>
					<el-col :span="12">
						<div class="c-content-right textCenter">
							<img src="../../assets/images/service_new/jcyj.png" style="width: 60%;" alt="" srcset="">
						</div>
					</el-col>
				</el-row>


				<el-row class="bgWhite mt40 fw-tab-box">
					<el-col :span="6">
						<a href="javascript:;" class="textCenter fontBold inlineBlock fw-tab fontNormal font14"
							:class="{'fw-active fontRed': fwTab == 4}" @click="handleChangeTab(4)">WEB端项目服务</a>
					</el-col>
					<el-col :span="6">
						<a href="javascript:;" class="textCenter fontBold inlineBlock fw-tab fontNormal font14"
							:class="{'fw-active fontRed': fwTab == 2}" @click="handleChangeTab(2)">移动端项目服务</a>
					</el-col>
					<el-col :span="6">
						<a href="javascript:;" class="textCenter fontBold inlineBlock fw-tab fontNormal font14"
							:class="{'fw-active fontRed': fwTab == 3}" @click="handleChangeTab(3)">培训项目服务</a>
					</el-col>
					<el-col :span="6">
						<a href="javascript:;" class="textCenter fontBold inlineBlock fw-tab fontNormal font14"
							:class="{'fw-active fontRed': fwTab == 1}" @click="handleChangeTab(1)">大数据项目服务</a>
					</el-col>
				</el-row>
			</div>
		</div>
		<!-- 顶部二级菜单部分 -->

		<div class="h30 bgWhite"></div>

		<!-- 大数据项目服务 -->
		<div v-show="fwTab == 1">
			<div class="bgWhite w100">
				<div class="w1100 dsj-main">
					<h2 class="textCenter">服务案例</h2>
					<p class="fontBold font18 textCenter">· 宏观和行业模块实现总量分析</p>
					<p class="fontBold font18 textCenter">· 铁矿石、煤焦、废钢、合金、钢坯、带钢、球墨铸铁、型材、棒材、螺纹钢、线材、管材、板
						·材模块实现钢铁产业链从原料到成品分析</p>
					<p class="fontBold font18 textCenter">· 熔剂、耐材等辅料模块·期货模块实现黑色商品市场分析</p>
					<p class="fontBold font18 textCenter">· 区域市场模块实现区域市场分析</p>
					<p class="fontBold font18 textCenter">· 钢铁企业对标模块·环保模块</p>
				</div>
			</div>

			<div class="bgGrey w100">
				<div class="w1100 dsj-main">
					<img src="../../assets/images/service_new/dsj_jb.png" alt="" class="w100">
				</div>
			</div>

			<div class="bgWhite w100">
				<div class="w1100 dsj-main">
					<img src="../../assets/images/service_new/dsj_py.png" alt="" class="w100">
				</div>
			</div>

			<div class="bgGrey w100">
				<div class="w1100 dsj-main">
					<img src="../../assets/images/service_new/dsj_py2.png" alt="" class="w100">
				</div>
			</div>

			<div class="bgWhite w100">
				<div class="w1100 dsj-main">
					<h3 class="textCenter font20 fontBold">实现目标</h3>
					<el-row :gutter="20">
						<el-col :span="8">
							<div class="dsj-mb-list bgGrey font18 fontNormal textCenter fontBold">输出建设一个完整的商业系统</div>
						</el-col>
						<el-col :span="8">
							<div class="dsj-mb-list bgGrey font18 fontNormal textCenter fontBold">实现大数据可视化优美展示界面</div>
						</el-col>
						<el-col :span="8">
							<div class="dsj-mb-list bgGrey font18 fontNormal textCenter fontBold">智能化市场分析预测与报告系统</div>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
		<!-- 大数据项目服务 -->

		<!-- 移动端服务 -->
		<div v-show="fwTab == 2">
			<div class="bgWhite w100">
				<div class="w1100 ydd-main">
					<el-row>
						<el-col :span="8">
							<div>
								<img src="../../assets/images/service_new/ydd_iphone.png" alt="" class="ydd-list1-img">
							</div>
						</el-col>
						<el-col :span="8">
							<div class="textCenter">
								<img src="../../assets/images/service_new/ydd_android.png" alt="" class="ydd-list1-img">
							</div>
						</el-col>
						<el-col :span="8">
							<div class="textRight">
								<img src="../../assets/images/service_new/ydd_code.png" alt="" class="ydd-list1-img">
							</div>
						</el-col>
					</el-row>

					<p class="fontNormal fontBold font20 textCenter">选择适合你的手机系统下载，或用手机扫描上方二维码在应用商店</p>
					<p class="fontRed fontBold font20 textCenter">搜索“唐宋钢铁”即可免费下载，或扫描上方二维码直接下载</p>

					<el-row>
						<el-col :span="12">
							<div class="textCenter">
								<img src="../../assets/images/service_new/ydd_downLoad1.png" alt=""
									class="ydd-list2-img">
							</div>
						</el-col>
						<el-col :span="12">
							<div class="textCenter">
								<img src="../../assets/images/service_new/ydd_downLoad2.png" alt=""
									class="ydd-list2-img">
							</div>
						</el-col>
					</el-row>

					<img src="../../assets/images/service_new/ydd_hangqing.png" alt="" class="w100">

					<el-row>
						<el-col :span="14">
							<div class="ydd-qyh-box">
								<img src="../../assets/images/service_new/ydd_qyh_title.png" alt="">
								<p class="font18 fontNormal">
									手机终端，核心数据，一键成图，钢坯数据，带钢数据，焦炭数据，铁矿石数据；唐宋信息产品重要的推送手段之一，具有随身、及时、方便等特点。</p>
							</div>
						</el-col>
						<el-col :span="10">
							<div class="ydd-qyh-box2 textCenter">
								<img src="../../assets/images/service_new/ydd_qyh_code.png" alt="">
							</div>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<div class="mt80">

								<div class="textCenter ydd-ss-left fontRed fontBold">
									<p>微信搜索</p>
									<p>唐宋大数据</p>
								</div>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="mt80">
								<div class="textCenter">
									<img src="../../assets/images/service_new/ydd_code.png" alt=""
										class="ydd-list1-img">
								</div>
							</div>
						</el-col>
					</el-row>
					
					<p class="fontRed fontBold font20 textCenter ">在微信中搜索“唐宋大数据”关注企业号，或扫描上方二维码直接下载</p>
					
					<el-row class="bgGrey mt80">
						<el-col :span="20" :offset="2">
							<div class="ydd-qyh-page">
								
								<img src="../../assets/images/service_new/ydd_qyh_page1.png" alt="">
								<img src="../../assets/images/service_new/ydd_qyh_page2.png" alt="">
							</div>
						</el-col>
					</el-row>
					
					<div class="mt80">
						<h2 class="ydd-title textCenter">带钢/钢坯/铁矿石/焦炭</h2>
						<img src="../../assets/images/service_new/ydd_dggp.png" alt="" class="w100 mt40">
					</div>
					
					<div class="mt80">
						<h2 class="ydd-title textCenter">
							价格/供需/库存/利润<br>
							基本面数据分析
						</h2>
						<img src="../../assets/images/service_new/ydd_jbm.png" alt="" class="w100 mt40">
					</div>
				</div>
			</div>
		</div>
		<!-- 移动端服务 -->
		
		<div class="h30 bgWhite"></div>
		
		
		<div v-show="fwTab==3" style="height: 4650px;overflow: hidden;">
			<iframe style="width: 100%;height: 4650px;overflow: hidden;border: none;" src="http://118.126.142.55:9090/industria/consultService/index.html"></iframe>
		</div>
		
		
		<!-- PC端服务 -->
		<div v-show="fwTab == 4">
			<div class="bgWhite w100">
				<div class="w1100 pc-main">
					<el-row>
						<el-col :span="8">
							<span class="pc-title-line inlineBlock"></span>
						</el-col>
						<el-col :span="8">
							<p class="fontRed pc-title textCenter">免费试用网址</p>
							<p class="fontRed pc-title textCenter">online.chinatsi.com</p>
							<p class="fontRed pc-title textCenter">或扫描上方二维码领取试用</p>
						</el-col>
						<el-col :span="8">
							<span class="pc-title-line inlineBlock"></span>
						</el-col>
					</el-row>
				</div>
					
					<div class="mt40 pc-sub-box bc-g">
						<div class="pc-contnet-group">
							<h2 class="pc-subtitle">可视化</h2>
							<p class="font20 fontLight fontBold">十大行业品类数据以及行业宏观、期货、津冀聚焦等涨跌信息行情变化即时送达</p>
							<img src="../../assets/images/service_new/jcyj_index.jpg" alt="" class="w100 mt40">
						</div>
					</div>
					
					<div class="mt40 pc-sub-box">
						<div class="pc-contnet-group">
							<h2 class="pc-subtitle">算法</h2>
							<p class="font20 fontLight fontBold">数据决定未来算法把握先机</p>
							<img src="../../assets/images/service_new/jcyj_index2.jpg" alt="" class="w100 mt40">
						</div>
					</div>
					
					<div class="mt40 pc-sub-box bc-g">
						<div class="pc-contnet-group">
							<h2 class="pc-subtitle">价差套利</h2>
							<p class="font20 fontLight fontBold">集研究之大成唐宋带您“研究”价差套利策略教你“赚差价”</p>
							<img src="../../assets/images/service_new/jcyj_index3.jpg" alt="" class="w100 mt40">
						</div>
					</div>
					
					<div class="mt40 pc-sub-box">
						<div class="pc-contnet-group">
							<h2 class="pc-subtitle">报告</h2>
							<p class="font20 fontLight fontBold">唐宋监测预警周报、100指数周报告、100指数分品种报告、唐尔街日报、投资策略报告...</p>
							<img src="../../assets/images/service_new/jcyj_index4.jpg" alt="" class="w100 mt40">
						</div>
					</div>
					
					<div class="mt40 pc-sub-box bc-g">
						<div class="pc-contnet-group">
							<h2 class="pc-subtitle">资讯/短信</h2>
							<p class="font20 fontLight fontBold">宏观/国际/行业/政策/唐宋视点每日更新；短信报价应有尽有。</p>
							<img src="../../assets/images/service_new/jcyj_index5.jpg" alt="" class="w100 mt40">
						</div>
					</div>
					
					<div class="mt40 pc-sub-box">
						<div class="pc-contnet-group">
							<h2 class="pc-subtitle">视频</h2>
							<p class="font20 fontLight fontBold">手把手教您如何使用预警系统</p>
							<img src="../../assets/images/service_new/jcyj_index6.jpg" alt="" class="w100 mt40">
						</div>
					</div>
					
					<div class="mt40 pc-sub-box bc-g">
						<div class="pc-contnet-group">
							<h2 class="pc-subtitle">行情地图</h2>
							<p class="font20 fontLight fontBold">全国十二个品种基准价一览表</p>
							<img src="../../assets/images/service_new/jcyj_index7.jpg" alt="" class="w100 mt40">
						</div>
					</div>

			</div>
		</div>
		<!-- PC端服务 -->
		<Footer></Footer>
	</div>
</template>

<script>
	import $ from 'jquery'
	import Header from '../../templates/header'
	import Footer from '../../templates/footer'
	export default {
		name: 'ServiceSystem',
		components: {
			Header,
			Footer
		},
		data() {
			return {
				nrTab: 4,
				fwTab: 4
			}
		},
		mounted() {
			// 初始化内容
		},
		methods: {
			//页面操作
			handleChangeTab(num) {
				this.fwTab = num;
			}
		},
	}
</script>

<style scoped>
	.w1100 {
		width: 1100px;
		margin: 0 auto;
	}

	.mt80 {
		margin-top: 80px;
	}
	.mb80 {
		margin-bottom: 80px;
	}

	.mt40 {
		margin-top: 40px;
	}

	.fw-tab-box {
		border-radius: 3px;
		margin-bottom: -90px;
		box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.1);
	}

	.h30 {
		height: 30px;
	}

	.service-top-box {
		height: 108px;
	}

	.s-top-container {
		/* height: 100vh; */
		background: url('../../assets/images/service_new/top_bg.png') no-repeat;
		background-size: 100% 100%;
	}

	.c-content {
		width: 1100px;
		padding: 60px 0;
		box-sizing: border-box;
		margin: 0 auto;
	}

	.c-content-left h2 {
		font-size: 32px;
		margin-bottom: 40px;
	}

	.c-content-left h3 {
		font-size: 28px;
		margin-bottom: 30px;
	}

	.c-content-left p {
		font-size: 16px;
		line-height: 30px;
		margin-bottom: 10px;
	}

	.nr-tab {
		padding-top: 20px;
	}

	.nr-tab a {
		display: inline-block;
		width: 150px;
		text-align: center;
		line-height: 40px;
		color: #a30000;
		box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
		background-color: #fff;
		margin-right: 20px;
		font-size: 14px;
		font-weight: bold;
		letter-spacing: 2px;
	}

	.nr-tab a.nr-active {
		background-color: #a30000;
		color: #fff;
	}

	.c-content-right {
		padding: 0 30px;
	}

	.fw-tab {
		margin-left: 10%;
		width: 80%;
		letter-spacing: 2px;
		line-height: 80px;
	}

	.fw-active {
		background: url('../../assets/images/service_new/menu_line.png') no-repeat;
		background-size: 100% auto;
	}

	.dsj-main,
	.ydd-main {
		padding: 60px 0;
	}

	.dsj-main h2 {
		font-size: 64px;
		color: #3939ab;
		margin-bottom: 60px;
		font-weight: normal;
	}

	.dsj-main p {
		line-height: 60px;
	}

	.dsj-mb-list {
		line-height: 80px;
		letter-spacing: 2px;
	}

	.dsj-main h3 {
		font-size: 28px;
		margin: 60px 0;
		letter-spacing: 8px;
	}

	.ydd-list1-img {
		width: 200px;
		margin-bottom: 60px;
	}

	.ydd-main p {
		line-height: 40px;
		letter-spacing: 2px;
	}

	.ydd-list2-img {
		width: 400px;
		margin: 100px 0;
	}

	.ydd-qyh-box {
		margin-top: 100px;
	}

	.ydd-qyh-box img {
		height: 50px;
		margin: 50px 0 80px 0;
	}

	.ydd-qyh-box p {
		letter-spacing: 4px;
		text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);
		font-size: 24px;
		line-height: 60px;
		width: 80%;
	}

	.ydd-qyh-box2 {
		margin-top: 60px;
	}

	.ydd-qyh-box2 img {
		width: 60%;
	}

	.ydd-ss-left {
		width: 200px;
		height: 200px;
		box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.1);
		border-radius: 2px;
		margin: 0 auto;
		padding-top: 40px;
		box-sizing: border-box;
	}

	.ydd-ss-left p {
		font-size: 26px;
		line-height: 50px;
	}
	.ydd-qyh-page {
		padding: 60px 0;
	}
	.ydd-qyh-page img:first-child {
		
		margin-right: 60px;
	}
	.ydd-qyh-page img {
		width: 45%;
	}
	.ydd-title {
		font-size: 30px;
		letter-spacing: 4px;
		padding: 15px 0;
		line-height: 50px;
	}
	.pc-title-line {
		width: 80%;
		border-bottom: 1px solid #333;
		height: 75px;
	}
	.pc-title {
		font-size: 30px;
		line-height: 50px;
	}
	.pc-sub-box h2{
		font-size: 32px;
		line-height: 100px;
	}
	.pc-sub-box{
		margin: 0px !important;
		padding-top: 20px !important;
		padding-bottom: 20px !important;
	}
	.pc-contnet-group{
		width: 1100px;
		margin: 0 auto;
	}
	.bc-g{
		background-color: #f2f2f2;
	}
</style>
